import type { ISignalsQueryKeyFactory } from "./types";

const SIGNALS_QUERY_KEY_BASE = "signals";

const SIGNAL_LIFECYCLE_TRANSITION_MUTATION_KEY = "signal-lifecycle-transition";

const SIGNAL_CREATE_MUTATION_KEY = "signal-create";

const ACCOUNT_SETTINGS_KEY = "account-signals-settings";

export const signalsQueryKeys: ISignalsQueryKeyFactory = {
    all() {
        return [SIGNALS_QUERY_KEY_BASE];
    },

    lifecycleTransition(identifier?: string) {
        const baseKey = [SIGNALS_QUERY_KEY_BASE, SIGNAL_LIFECYCLE_TRANSITION_MUTATION_KEY];

        return identifier ? [...baseKey, identifier] : baseKey;
    },

    createSignal(identifier?: string) {
        const baseKey = [SIGNALS_QUERY_KEY_BASE, SIGNAL_CREATE_MUTATION_KEY];

        return identifier ? [...baseKey, identifier] : baseKey;
    },

    accountSettings() {
        return [ACCOUNT_SETTINGS_KEY];
    },
};
